class destroyController{
  constructor(){
    'ngInject';
  }

  $onClose(){
    this.close({$value: 'cancel'});
  }

  $onDestroy(){
    this.close({$value: 'confirm'});
  }

}

export default destroyController;


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/destroy/destroy.controller.js
 **/